import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { CedProductService } from 'app/management/ced-products/ced-product.service';
import { UserProfile } from 'app/_models';
import { DossierHelpPlan } from 'app/_models/dossier-help-plan.model';
import { CedNotificationService } from 'ced-ng-library';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { purshaseService } from '../purshase.service';
import { serviceModel } from '../service-model';

@Component({
  selector: 'app-purshase-service-details',
  templateUrl: './purshase-service-details.component.html',
  styleUrls: ['./purshase-service-details.component.scss']
})
export class PurshaseServiceDetailsComponent extends DialogContentBase implements OnInit, OnDestroy {
  public purshaseForm = new FormGroup({});
  private _subject$: Subject<boolean> = new Subject();
  values = [{text:"Yes",id:0},{text:"No",id:1}];
  private selectedPurshaseService : serviceModel = null;
  private profile: UserProfile = new UserProfile();
  public saleServices : serviceModel []= [];
  public helpPlans :DossierHelpPlan[] = [];
  constructor(dialog: DialogRef,
    private purshaseService : purshaseService,
    private cedNotificationService: CedNotificationService,
    private saleService: CedProductService) 
  {super(dialog) }

  ngOnInit() {
    this.initForm();
    this.getSaleServices();
    this.getHelpPlansByService();
  }

  initForm(){
    this.purshaseForm = new FormGroup({
        code: new FormControl(null, Validators.required),
        shortName: new FormControl(null, Validators.required),
        longName: new FormControl(null, Validators.required),
        saleService: new FormControl(null, Validators.required),
        active: new FormControl(null, Validators.required),
        comment: new FormControl(""),
        helpPlans: new FormControl(null)
    });
  }
  
  populateControls(){
    if(this.selectedPurshaseService != null){
        this.purshaseForm.controls.code.setValue(this.selectedPurshaseService.itmCode);
        this.purshaseForm.controls.shortName.setValue(this.selectedPurshaseService.itmShortName);
        this.purshaseForm.controls.longName.setValue(this.selectedPurshaseService.itmLongName);
        if(this.selectedPurshaseService.itmInactive == true){
          this.purshaseForm.controls.active.setValue(this.values[1]);
        }else if(this.selectedPurshaseService.itmInactive == false){
          this.purshaseForm.controls.active.setValue(this.values[0]);
        }
        this.purshaseForm.controls.saleService.setValue(this.selectedPurshaseService.itmProduct);
    }                                       
  }
  public save() {
    let saleService = new serviceModel ();                
    saleService.itmCode = this.purshaseForm.controls.code.value;
    saleService.itmShortName = this.purshaseForm.controls.shortName.value;
    saleService.itmLongName =  this.purshaseForm.controls.longName.value;
    saleService.itmInactive =  this.purshaseForm.controls.active.value.id;
    saleService.itmComment = this.purshaseForm.controls.comment.value;
    saleService.itmProductId = this.purshaseForm.controls.saleService.value.prdId

    if(this.purshaseForm.valid){
        if(this.selectedPurshaseService == null){
          saleService.itmCreatedBy = this.profile.emailAddress;          
          saleService.itmLastModifiedBy = this.profile.emailAddress;      
          this.purshaseService
          .save(saleService)
          .pipe(takeUntil(this._subject$))
          .subscribe(
            (res:any) => {
             
                this.dialog.close(true);
                this.cedNotificationService.success("NOTIFICATIONS.SAVE_SUCCEDED");
              
            }
          )
      }
      else{
        saleService.itmId = this.selectedPurshaseService.itmId;
        saleService.itmLastModifiedBy = this.profile.emailAddress;
        this.purshaseService
        .update(saleService)
        .pipe(takeUntil(this._subject$))
        .subscribe(
          (res:any) => {
           
              this.dialog.close(true);
              this.cedNotificationService.success("NOTIFICATIONS.UPDATE_SUCCEDED");
          }
        )
      }
    } 
    else
    this.cedNotificationService.error("NOTIFICATIONS.REQUIRED_DATA_MISSING")
}

getSaleServices(){
  this.saleService.getProductByClassification()
  .pipe(takeUntil(this._subject$))
  .subscribe((data: any) => {
    this.saleServices = data.sort((a, b) => a.prdShortName.toLowerCase() > b.prdShortName.toLowerCase() ? 1 : -1);
  });
}
getHelpPlansByService(){
  this.purshaseService.getHelpPlansByService()
  .pipe(takeUntil(this._subject$))
  .subscribe((data: any) => {
   this.helpPlans = data.sort((a, b) => a.hplCode.toLowerCase() > b.hplCode.toLowerCase() ? 1 : -1);
   this.populateControls();
  });
}
  public cancel() {
    this.dialog.close(null);
  } 

  ngOnDestroy(): void {
    this._subject$.next();
    this._subject$.complete();
  }
}